import { useEffect } from 'react';
import GoogleAnalytics from 'react-ga';

const useGATracker = (location) => {
  useEffect(() => {
    const trackPage = (page) => {
      GoogleAnalytics.set({ page });
      GoogleAnalytics.pageview(page);
    };

    const page = location.pathname + location.search;
    trackPage(page);

    return () => {
      const nextPage = location.pathname + location.search;
      if (page !== nextPage) {
        trackPage(nextPage);
      }
    };
  }, [location]);
};

export default useGATracker;
